import { type Components, type Theme } from "@mui/material/styles";

export const pagination: Components<Theme>["MuiPagination"] = {
  defaultProps: {
    shape: "rounded",
    showFirstButton: true,
    showLastButton: true,
  },
};
